// AboutPage.js
import React from 'react';

const AboutPage = () => {
  return <h1>About Page</h1>;
};

export default AboutPage;